import {autocomplete} from 'getaddress-autocomplete';

const GetAddress = {
	apiKey: null,
	init: () => {

		const apikey = document.querySelector(`[data-getaddress-apikey]`);
		if(!apikey){
		    return;
		}
		GetAddress.apiKey = apikey.getAttribute('data-getaddress-apikey');
		if(!GetAddress.apiKey) return;


		autocomplete(
			'billing_address_1',
			GetAddress.apiKey,
			{
				output_fields: GetAddress.getFields('billing'),
			}
		)

		autocomplete(
			'shipping_address_1',
			GetAddress.apiKey,
			{
				output_fields: GetAddress.getFields('shipping'),
			}
		)


		GetAddress.setCurrentCountriesClass();
		GetAddress.initCountryChange();
	},

	getFields: (type) => {
		return {
			line_1: type+'_address_1',  /* The id of the element bound to 'line_1' */
			line_2: type+'_address_2',  /* The id of the element bound to 'line_2' */
			town_or_city: type+'_city',  /* The id of the element bound to 'town_or_city' */
			county: type+'_state',  /* The id of the element bound to 'county' */
			postcode: type+'_postcode',  /* The id of the element bound to 'postcode' */
		};
	},

	setCurrentCountriesClass: () => {
		GetAddress.setCurrentCountryClass('billing');
		GetAddress.setCurrentCountryClass('shipping');
	},

	setCurrentCountryClass: (type) => {
		const country = document.querySelector(`select#${type}_country`);
		if(!country){
		    return;
		}

		const wrapper = country.closest(`.woocommerce-${type}-fields`);
		if(!wrapper) return;

		wrapper.setAttribute('data-country-code', country.value);
	},

	initCountryChange: () => {
		setInterval(() => {
			GetAddress.setCurrentCountriesClass();
		}, 1000);
	}
}

export default GetAddress;
